import React, { useCallback, useMemo, useState } from 'react';
import _get from 'lodash/get';
import { Attachment, Documentation } from 'graphql-common';
import FileViewerModal from '@lib/components/FileViewerModal/FileViewerModal';
import DocumentVersionNotes from '@lib/components/DocumentationPreview/DocumentVersionNotes';
import { APP_URLS } from 'constants/urls';

export default function useDocumentActions() {
  const [fileViewerDocument, setFileViewerDocument] =
    useState<Documentation | null>(null);
  const [versionNotesDocument, setVersionNotesDocument] =
    useState<Documentation | null>(null);

  const onViewDocument = useCallback((item: Documentation) => {
    setFileViewerDocument(item);
  }, []);

  const onVersionNotes = useCallback((item: Documentation) => {
    setVersionNotesDocument(item);
  }, []);

  const onDetails = useCallback((item: Documentation) => {
    window.open(
      APP_URLS.dashboard.documentation.view.getDynamicPath({
        pathParts: { id: item.id },
      }),
      '_blank',
    );
  }, []);

  const renderDocumentModals = useMemo(
    () => (
      <>
        <FileViewerModal
          attachment={
            _get(fileViewerDocument, [
              'currentVersion',
              'attachmentAttached',
            ]) as Attachment
          }
          isOpen={!!fileViewerDocument}
          onClose={() => setFileViewerDocument(null)}
          useDownloadTool={false}
        />
        <DocumentVersionNotes
          isOpen={!!versionNotesDocument}
          notes={_get(versionNotesDocument, ['currentVersion', 'notes']) || ''}
          onClose={() => setVersionNotesDocument(null)}
        />
      </>
    ),
    [fileViewerDocument, versionNotesDocument],
  );

  return {
    onViewDocument,
    onVersionNotes,
    onDetails,
    renderDocumentModals,
  };
}
